export default __webpack_public_path__ + "static/media/bread(1).2fbb5c91.png";